import { logger } from '@gem/modules/logger';

import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

import { getCommitMessages } from './getCommitMessages';

export const removeMembersFromSecretGroup = async (
  groupId: string,
  membersIds: string[]
): Promise<{ error: string | null }> => {
  try {
    const mlsGroup = MlsStorageService.loadGroup(groupId);

    if (!mlsGroup) {
      throw new Error('MlsGroup does not exist');
    }

    const removeMembersResult = MlsStorageService.removeMembersByIdOrDeviceId(membersIds, mlsGroup);

    if (!removeMembersResult) {
      return { error: null };
    }

    const response = await e2eeModel.removeSecretGroupParticipants({
      userIds: membersIds,
      commit: { payload: removeMembersResult.commit, epoch: Number(removeMembersResult.epoch) },
      groupId,
    });

    if (response.needToSyncCommits) {
      await getCommitMessages(groupId, Number(mlsGroup.currentEpoch()));
      await removeMembersFromSecretGroup(groupId, membersIds);
    } else {
      MlsStorageService.processMyWelcomeCommit(removeMembersResult.commitOutput, mlsGroup);
    }

    return { error: null };
  } catch (error) {
    logger.get('Tasks').error('e2ee.removeMembersToSecretGroup', error);
    return { error: error.message };
  }
};
